import queryString from "query-string";
import { makeBackendGetCallWithJsonResponse } from "../../../store/utils/fetch";
import { Trophy } from "../../../store/models/trophy";
import { LOAD_TROPHIES } from "../../../store/utils/routes";
import { promiseEngineEarsHandler } from "../../helpers";

interface getTrophiesParams {
  userId?: number;
  artistId?: number;
  engineerId?: number;
  studioId?: number;
  studioRoomId?: number;
}

export const getTrophies = ({
  userId,
  artistId,
  engineerId,
  studioId,
  studioRoomId,
}: getTrophiesParams) => {
  const params = queryString.stringify({
    user_id: userId?.toString(),
    artist_id: artistId?.toString(),
    engineer_id: engineerId?.toString(),
    studio_id: studioId?.toString(),
    studio_room_id: studioRoomId?.toString(),
  });

  return makeBackendGetCallWithJsonResponse<Trophy[]>(
    LOAD_TROPHIES,
    `?${params}`,
  ).then(promiseEngineEarsHandler);
};
